import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import  Page  from '../../components/Page';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results, AddRole } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const MasterRoles = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [isadd, setIsadd] = useState(false);
  const [roleobj, setRoleobj] = useState({});
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);

  async function fetchroles()
  {
    
    let masterroles_arr = await sendNetworkRequest('/admin/getroles', {}, {},false)
    setOrders(masterroles_arr)
  }
  function dismiss(){
    setIsadd(false)
    setRoleobj({})
  }

  function addrole(){
    setIsadd(true)
  }
  function editrole(roleobj)
  {
    setRoleobj(roleobj)
    setIsadd(true)
  }
  async function updaterolestatus(roleobj, status)
  {
    let bodycontent = {}
    bodycontent['status'] = status;
    
    if(roleobj)
    {
      bodycontent['id'] = roleobj.id;
      bodycontent['name'] = roleobj.name;

     
    }

    let masterroles_arr = await sendNetworkRequest('/admin/addrole', {}, bodycontent,false)

    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: masterroles_arr.status,
      msg: masterroles_arr.message,
      vertical: "top",
    });
   
      fetchroles()
    
    
  }
  async function updaterole(rolename,roleobj)
  {

    let bodycontent = {}
    bodycontent['name'] = rolename;
    if(rolename == null || rolename.length == 0 )
    {
      snackbarCtx.setSnack({
        ...snackbarCtx,
        open: true,
        type: "error",
        msg: "Please enter role name",
        vertical: "top",
      });
    }else{
    if(roleobj && roleobj.id)
    {
    
      bodycontent['id'] = roleobj.id;
    bodycontent['status']  = roleobj.status 
  }
    let masterroles_arr = await sendNetworkRequest('/admin/addrole', {}, bodycontent,false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: masterroles_arr.status,
      msg: masterroles_arr.message,
      vertical: "top",
    });
    if(masterroles_arr && masterroles_arr.status == "success")
    {
    setRoleobj({})

    setIsadd(false)
    fetchroles()
    }
  }
    
    
   
  }
  useEffect(() => {
   fetchroles()
   
}, []);

  return (
    <Page
      className={classes.root}
      title="Roles Management"
    >
      <Header onAdd={addrole}/>
      {isadd ? <AddRole onUpdate={updaterole} onDismiss={dismiss} roleObj={roleobj}/> : null }
      <Results
        onEdit={editrole}
        onUpdatestattus={updaterolestatus}
        onupdatestatus={editrole}
        className={classes.results}
        orders={orders} //
      />
    </Page>
  );
});

export default MasterRoles;
